import { Component, OnInit } from '@angular/core';
import { MenuItems, MenuItem } from '../../core/menu/MenuItem';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../core/models/user.model';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { PathRoutes } from '../../core/configuration/pathRoutes';
import { LivesSessionHelper } from '../../core/helper/livesSessionHelper';

@Component({
  selector: 'app-button-menu',
  templateUrl: './button-menu.component.html',
  styleUrls: ['./button-menu.component.scss'],
})
export class ButtonMenuComponent implements OnInit {
  menuChildItems: MenuItem[];
  menuItemsFiltered: MenuItem[];
  usuario: User;

  constructor(
    protected _location: Location,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _session: SessionHelper,
    private _livesSession: LivesSessionHelper,
  ) {
    this.usuario = _session.User;
  }

  buildButton(data: any) {

    this.menuItemsFiltered = MenuItems;//this.usuario.esAdmin ? MenuItems : MenuItems.filter(menuItem => menuItem.onlyAdmin === false);

    const parentMenuItem = this.menuItemsFiltered.find(
      menuItem =>
        menuItem.path === data.childrenParentPath && menuItem.isParent
    );

    if (parentMenuItem) {
      this.menuChildItems = parentMenuItem.childs;
      // this.menuChildItems =  this.usuario.esAdmin
      // ? parentMenuItem.childs
      // : parentMenuItem.childs.filter(menuItem => menuItem.onlyAdmin === false);
    }
  }

  ngOnInit() {
    this._route.data.subscribe((data: any) => {
      const portalEmpleadoButton = data['app'];
      const hostelButton = data['hostel'];

      //si es portal del empleado compruebo, si no construyo directamente
      if (portalEmpleadoButton) {

        // Si tiene licencia del portal del empleado le muestro los botones, si no redirijo a la landing
        if (this._livesSession.LivesHR == 'true' || this._livesSession.Attendance == 'true') {
          this.buildButton(data)
        } else {
          this._router.navigate([PathRoutes.appRedirectApp], { relativeTo: this._route.parent });

          // this._router.navigate([PathRoutes.app, PathRoutes.appRedirect]);
        }

      } else if (hostelButton) {

        // Si tiene licencia del portal del empleado le muestro los botones, si no redirijo a la landing
        if (this._livesSession.HostelHR == 'true') {
          this.buildButton(data)
        } else {
          this._router.navigate([PathRoutes.appRedirectHostel], { relativeTo: this._route.parent });

          // this._router.navigate([PathRoutes.app, PathRoutes.appRedirect]);
        }

      } else {
        this.buildButton(data)
      }

    });
  }
}
